/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData, FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataFromJSONTyped, FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataToJSON, } from './FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData';
export function FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataFromJSON(json) {
    return FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData(json)) {
        return FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataToJSON(json) {
    return FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData(value)) {
        return FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingData.js.map